var render, staticRenderFns
import script from "./SupportingImage.vue?vue&type=script&lang=js"
export * from "./SupportingImage.vue?vue&type=script&lang=js"
import style0 from "./SupportingImage.vue?vue&type=style&index=0&id=7be151c3&prod&scoped=true&lang=scss"
import style1 from "./SupportingImage.vue?vue&type=style&index=1&id=7be151c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be151c3",
  null
  
)

export default component.exports